import React from "react";
const { createContext, useState, useContext, useEffect } = require("react");

const SiteContext = createContext();

function SiteProvider({ children }) {
  const [banRooms, setBanRooms] = useState([]);
  const [locations, setLocations] = useState([]);

  useEffect(() => {
    async function getBanRooms() {
      console.log("start");
      const res = await fetch("http://localhost:3001/api/banquetrooms");
      const data = await res.json();
      sessionStorage.setItem("banRooms", JSON.stringify(data));
    }

    async function getLocations() {
      const res = await fetch("http://localhost:3001/api/locations");
      const data = await res.json();
      sessionStorage.setItem("locations", JSON.stringify(data));
    }
    getBanRooms();
    getLocations();
  }, []);

  return (
    <SiteContext.Provider value={{ banRooms, locations }}>
      {children}
    </SiteContext.Provider>
  );
}

function useSiteInfo() {
  const context = useContext(SiteContext);
  return context;
}

export { SiteProvider, useSiteInfo };
